import { Client } from './Client'
import type { RequestOptions } from './types'

export class RpcClient extends Client {
  execute<Body extends Record<string, unknown>, Response extends Record<string, unknown>>(
    signature: string,
    payload: Body,
    options: RequestOptions = {},
  ): Promise<Response> {
    return this.call(
      'POST',
      '',
      {
        signature,
        body: payload,
      },
      {},
      options,
    )
  }
}
